import { UIBox } from '@/components/ui/Box';
import { Typography } from '@/components/ui/Typography';
import { colors, theme } from '@/theme';
import { ADJUSTMENT_NEGATIVE, ADJUSTMENT_POSITIVE } from '@/utils/const';
import styled, { css } from 'styled-components';

export const GridStyles = css`
  display: grid;
  align-items: center;
  gap: 16px;

  grid-template-columns: 2fr 2fr repeat(4, 1fr) 0.5fr;

  ${theme.breakpoints.down('md')} {
    grid-template-columns:
      minmax(120px, 2fr)
      minmax(140px, 2fr)
      repeat(4, minmax(60px, 0.5fr))
      minmax(60px, 0.5fr)
  }
`;

export const StyledGrid = styled(UIBox)`
  width: 100%;
  flex-direction: column;
  margin-bottom: 120px;

  & > * {
    padding: 0;
  }
`;

export const StyledGridHeader = styled(UIBox)`
  width: 100%;
  padding: 8px 24px;
  border-bottom: 1px solid #4b4b4b;
  ${GridStyles}
  .text-number {
    text-align: left;
  }
`;

export const StyledRowWrapper = styled(UIBox)`
  flex-direction: column;

  &:not(:nth-of-type(even)) {
    background: #fbfbfb;
    border-bottom: 1px solid #ededed;
  }
  &:not(:nth-of-type(odd)) {
    background: ${colors.white};
  }
`;

export const StyledGridRow = styled(UIBox)`
  width: 100%;
  padding: 11px 24px;
`;

export const StyledGridRowContent = styled(UIBox)`
  width: 100%;
  padding: 8px 0;
  ${GridStyles}
`;

export const StyledSpan = styled(Typography)<{ $movementType?: string }>`
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ $movementType }): string =>
    $movementType && ADJUSTMENT_NEGATIVE.includes($movementType)
      ? colors.red
      : $movementType && ADJUSTMENT_POSITIVE.includes($movementType)
      ? colors.green
      : colors.black}!important;
  &.text-number {
    text-align: left;
  }
`;

export const StyledUserId = styled(UIBox)`
  gap: 8px;
  align-items: center;
`;
